import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { authHelper } from "../../../utils/helpers";
import { useNavigate } from "react-router-dom";
import { Routes } from "../../../utils/constants";
import { fetchLogoutProxy } from "../../../utils/helpers/api";
import { useGlobalState } from "../../../contexts/GlobalContext";

const FinistWithdrawal: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setStateValue } = useGlobalState();

  useEffect(() => {
    handleSubmit();
    document.title = '宣伝会議 : アカウント管理 | 退会完了';
  }, []);

  const handleSubmit = async () => {
    setStateValue("loader", true);
    try {
      await fetchLogoutProxy();
    } catch (error) {
      return error;
    } finally {
      authHelper.logOut();
      setStateValue("loader", false);
    }
  };

  return (
    <Box className="page__withdrawal">
      <div className="header-tit">{t("features.withdrawal.finish.title")}</div>
      <Box className="center">
        <p className="mb8">
          {t("features.withdrawal.finish.completeMessage")}
          <br />
          {t("features.withdrawal.finish.farewellMessage")}
        </p>
        <div className="btn btn-primary mt8" onClick={()=> navigate(Routes.USERGUEST)}>
          {t("common.backToHome")}
        </div>
      </Box>
    </Box>
  );
};

export default FinistWithdrawal;
